import * as Schema from 'owa-graph-schema';
import { Reference, FieldReadFunction } from '@apollo/client';

const __typename: Schema.MailFolder['__typename'] = 'MailFolder';

type FolderPolicy = {
    Query: {
        fields: {
            [P in 'folder']: FieldReadFunction<any, Reference>;
        };
    };
};

export const folderTypePolicies: FolderPolicy = {
    Query: {
        fields: {
            folder(_, { args, toReference }) {
                return toReference({
                    __typename,
                    id: args.id,
                });
            },
        },
    },
};
